export default __webpack_public_path__ + "static/char-40-anr-4bfb2c2d48c417020e8db763d8fe3906.webp";